// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"af8705a9","453":"b0dc4fff","553":"f52cb67d","977":"0ce4f63f"}[chunkId] + ".chunk.js";
};